import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'

export default {
	path: '/exam_manage',
	name: 'examManage',
	meta: {
		title: '考试管理',
		keepAlive: false
	},
	component: Layout,
	redirect: '/exam_manage/exam_list',
	children: [
		{
			path: 'exam_list',
			name: 'examList',
			meta: {
				title: '考试列表',
				keepAlive: true
			},
			component: resolve => require(['@/views/examManage/examList/Index.vue'], resolve),
		},
		{
			path: 'exam_list',
			name: 'examLists',
			meta: {
				title: '考试列表',
				keepAlive: true
			},
			component: Empty,
			children: [
				{
					path: 'exam_list_result',
					name: 'examListResult',
					meta: {
						title: '成绩列表',
						keepAlive: true
					},
					component: resolve => require(['@/views/examManage/components/examlistResultList.vue'], resolve),
				},
				{
					path: 'new_exam',
					name: 'newExam',
					meta: {
						title: '新建考试',
						keepAlive: true
					},
					component: resolve => require(['@/views/examManage/insertOrUpdateExam/Index.vue'], resolve),
				},
				{
					path: 'new_exam_edit',
					name: 'newEditExam',
					meta: {
						title: '编辑考试',
						keepAlive: true
					},
					component: resolve => require(['@/views/examManage/insertOrUpdateExam/Index.vue'], resolve),
				},
				{
					path: 'new_exam_preview',
					name: 'newPreviewExam',
					meta: {
						title: '预览考试',
						keepAlive: true
					},
					component: resolve => require(['@/views/examManage/insertOrUpdateExam/Index.vue'], resolve),
				},
			]
		},
		{
			path: 'test_paper_analysis',
			name: 'testPaperAnalysis',
			meta: {
				title: '试卷分析',
				keepAlive: true
			},
			component: resolve => require(['@/views/examManage/testPaperAnalysis/Index.vue'], resolve),
		},
		{
			path: 'test_paper_manage',
			name: 'testPaperManage',
			meta: {
				title: '试卷管理',
				keepAlive: true
			},
			component: resolve => require(['@/views/examManage/testPaperManage/Index.vue'], resolve),
		},
	]
}
